import { PhoneFrame } from "@/components/marketing";
import { ChevronLeft } from "lucide-react";
import { channelPreview } from "../../../../data";

const { sms } = channelPreview;

// The campaign as a plain SMS in the phone's Messages app: the sender ID at
// the top, then one grey incoming bubble with the offer and a short link.
const SmsPreview = () => (
  <PhoneFrame contentClassName="grid content-start gap-3 pb-9 text-ink">
    <div className="grid justify-items-center gap-1 border-b border-line px-3 pb-3">
      <ChevronLeft
        aria-hidden="true"
        className="size-5 justify-self-start text-tone-sky-ink"
      />
      <span className="-mt-5 grid size-11 place-items-center rounded-full bg-line text-sm font-bold text-ink-muted">
        {sms.senderInitials}
      </span>
      <b className="text-[12.5px]">{sms.sender}</b>
    </div>
    <small className="text-center text-[10.5px] text-ink-muted">
      {sms.when}
    </small>
    <p className="mx-3 max-w-[82%] rounded-[18px] rounded-bl-md bg-paper px-3 py-2 text-[12.5px] leading-snug">
      {sms.text} <span className="text-tone-sky-ink underline">{sms.link}</span>
    </p>
  </PhoneFrame>
);

export default SmsPreview;
